import React from 'react';

import i18next from 'i18next';

import { RebrandCaret } from 'src/app/components/icons/rebrand-caret';
import { Input, InputAdornment } from 'src/app/components/lib/input';

import type { SxProps } from '@mui/material';
import type { DropdownMenuOption } from 'src/app/components/lib/dropdown/menu/types';

type MultiSelectInputProps = {
  automationId?: string;
  className?: string;
  disabled?: boolean;
  errorMessage?: string;
  gridColumns?: 4 | 6;
  handleClick: (event: React.MouseEvent<HTMLElement>) => void;
  helpText?: string;
  id?: number | string;
  label?: React.ReactElement | string;
  labelPlacement?: 'bottom' | 'end' | 'start' | 'top';
  required?: boolean;
  sx?: SxProps;
  tooltip?: string;
  value: DropdownMenuOption;
  width?: string;
};

export function DropdownInputSingle({
  className,
  gridColumns,
  handleClick,
  helpText = '',
  id,
  label,
  labelPlacement,
  required,
  sx,
  tooltip,
  value,
  width,
  automationId = '',
  errorMessage = '',
  disabled = false,
}: MultiSelectInputProps) {
  const hasValue = value?.id && String(value.id).length > 0;
  const selectionText = hasValue ? value?.label : '';

  return (
    <Input
      autoComplete='off'
      automationId={automationId}
      className={className}
      disabled={disabled}
      endAdornment={
        <InputAdornment position='end'>
          <RebrandCaret color='var(--color-gray-70)' height='7px' width='14px' />
        </InputAdornment>
      }
      errorMessage={errorMessage}
      gridColumns={gridColumns}
      id={String(id)}
      label={label}
      labelPlacement={labelPlacement}
      placeholder={i18next.t(helpText)}
      required={required}
      sx={sx}
      tooltip={tooltip}
      value={selectionText}
      width={width}
      onClick={handleClick}
    />
  );
}
